module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAARElEQVQoFZXBMQ7AQAzDMOn/j0493FAEWUxKSUpSkpKUpCTLBGFwkGWCMDjIM8HB4EeeCQ4GP7JMEAYHWSYIg4OUpPQB3uAYD+nI0W8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_10.png
// module id = 232
// module chunks = 0